"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Builder = _interopRequireDefault(require("../Components/Builder"));

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

var _Availability = require("../Availability");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Cart extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "catalog", null);

    _defineProperty(this, "total", null);
  }

  static fromObject(obj) {
    let c = new Cart();
    c.catalog = _Builder.default.mountSchema(obj.catalog);
    let pointer = 0;
    const precision = Math.pow(10, 2);
    c.catalog.items.map(item => {
      pointer += parseInt(item.getPrice() * precision);
    });
    c.total = parseFloat((pointer / precision).toFixed(2));
    return c;
  }

  validate() {
    if (this.catalog.length == 0) {
      throw new Error('Carrinho vazio!');
    }

    let catalog = this.trigger('cart/getCatalogList');
    let storeConfigs = this.trigger('cart/getStoreConfigs');

    let catalogTree = _Builder.default.mountSchema(catalog);

    let catalogIds = [];
    let catalogUnavailableIds = [];

    _Builder.default.executeOnSchema(catalogTree, item => {
      item.show = !!item.show && (0, _Availability.isAvailable)(item, null, storeConfigs.timezoneOffset);

      if (!item.show) {
        if (item.type == 'category') {
          item.items.map(subitem => {
            catalogUnavailableIds.push(subitem._id);
          });
        } else {
          catalogUnavailableIds.push(item._id);
        }
      }

      if (item._id && item.type != 'pizza') {
        catalogIds.push(item._id);
      }
    });

    let ignoreItems = ['catalog', 'pizza'];

    _Builder.default.executeOnSchema(this.catalog, item => {
      if (catalogUnavailableIds.indexOf(item._id) < -1) {
        throw new Error('Produtos indisponíveis no carrinho');
      }

      if (ignoreItems.indexOf(item.type) == -1 && catalogIds.indexOf(item._id) == -1) {
        throw new Error('Carrinho inválido!');
      }
    });
  }

}

exports.default = Cart;